import { Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class ScreenResolutionService {
  isBrowser = false;

  private mobileBreakpoint = 768;
  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isMobile(): boolean {
    if (this.isBrowser) {
      return window.innerWidth <= this.mobileBreakpoint;
    }
    return false;
  }
}
